import axios from 'axios';
import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';

import { getUrl } from '@/config/api.routes';
import { alphabetSort } from '@/libs';
import { CRUDStoreBuilder, updateKeywordsActionBuilder } from '../StoreBuilder';

const routingAlias = 'management.tags';

export default merge(
  new CRUDStoreBuilder(
    'management.tags',
    'tag',
    [],
    'data.models',
    true,
  ).createStore(),
  {
    getters: {
      tags: state => state.tags,
      sortedTagNames: state => cloneDeep(state.tags)
        .sort(alphabetSort)
        .map(tag => tag.name),
      tagModel: () => ({
        name: '',
        keywords: [],
      }),
    },
    actions: {
      createTag({ commit }, [item]) {
        return axios.post(getUrl(routingAlias), item).then(data => {
          commit('POST_TAG_SUCCESS', data.data);
          return data;
        });
      },
      deleteTag({ commit }, tag) {
        const { id } = tag;
        return axios.put(`${getUrl(routingAlias)}/${id}`, { ...tag, archived: true }).then(data => {
          commit('DELETE_TAG_SUCCESS', id);
          return data;
        });
      },
      async export(_, hideArchived) {
        return await axios.get(`${getUrl(routingAlias)}/export`, { params: { hide_archived: hideArchived } });
      },
      async import(_, params = []) {
        const [formData, onUploadProgress] = params;
        const config = {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress,
        };
        return (await axios.put(`${getUrl(routingAlias)}/import`, formData, config)).data;
      },
      ...updateKeywordsActionBuilder(routingAlias),
    },
  },
);
